// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'E:/Projects/work-insurance-admin-pc/node_modules/.pnpm/@umijs+renderer-react@4.6.2_ea16bafe81ebfb85e709c3eb98271dca/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
